<template>
  <div class="graduate-apply-form">
    <!-- 学生基本信息 -->
    <div class="card student-info-card">
      <div class="card-header">
        <h3>学生基本信息</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>学生姓名</label>
            <div class="form-value">{{ studentInfo.stuName }}</div>
          </div>
          <div class="form-item">
            <label>学号</label>
            <div class="form-value">{{ studentInfo.stuNo }}</div>
          </div>
          <div class="form-item">
            <label>校外教学点</label>
            <div class="form-value">{{ studentInfo.siteName }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>专业</label>
            <div class="form-value">{{ studentInfo.proName }}</div>
          </div>
          <div class="form-item">
            <label>层次</label>
            <div class="form-value">{{ studentInfo.learnLevel }}</div>
          </div>
          <div class="form-item">
            <label>前置学历是否通过</label>
            <div
              class="form-value"
              :class="
                studentInfo.preEducationPass_dictText === '是'
                  ? 'success'
                  : 'error'
              "
            >
              {{ studentInfo.preEducationPass_dictText }}
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>学历照片是否通过</label>
            <div
              class="form-value"
              :class="
                studentInfo.educationImg_dictText === '是' ? 'success' : 'error'
              "
            >
              {{ studentInfo.educationImg_dictText }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 论文相关 -->
    <div class="card thesis-info-card">
      <div class="card-header">
        <h3>论文相关</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>论文初稿上传时间</label>
            <div class="form-value">{{ studentInfo.draftUploadTime }}</div>
          </div>
          <div class="form-item">
            <label>论文终稿上传时间</label>
            <div class="form-value">{{ studentInfo.finalUploadTime }}</div>
          </div>
          <div class="form-item">
            <label>是否申请学位</label>
            <div
              class="form-value"
              :class="
                studentInfo.applyDegree_dictText === '是' ? 'success' : 'error'
              "
            >
              {{ studentInfo.applyDegree_dictText }}
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>评阅成绩</label>
            <div class="form-value">{{ studentInfo.thesisScore }}</div>
          </div>
          <div class="form-item">
            <label>总评成绩</label>
            <div class="form-value">{{ studentInfo.finalScore }}</div>
          </div>
          <div class="form-item">
            <label>答辩成绩</label>
            <div class="form-value">{{ studentInfo.defenseScore }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平均成绩及学分 -->
    <div class="card score-info-card">
      <div class="card-header">
        <h3>平均成绩及学分</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>论文或社会调查已获学分</label>
            <div class="form-value">{{ studentInfo.thesisCredit }}</div>
          </div>
          <div class="form-item">
            <label>专业实习已获学分</label>
            <div class="form-value">{{ studentInfo.practiceCredit }}</div>
          </div>
          <div class="form-item">
            <label>平均成绩</label>
            <div class="form-value">{{ studentInfo.avgScore }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>选修课已获学分</label>
            <div class="form-value">{{ studentInfo.electiveCredit }}</div>
          </div>
          <div class="form-item">
            <label>必修课程已获学分</label>
            <div class="form-value">{{ studentInfo.compulsoryCredit }}</div>
          </div>
          <div class="form-item">
            <label>已修学分</label>
            <div class="form-value">{{ studentInfo.completedCredit }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>学分完成情况</label>
            <div
              class="form-value"
              :class="
                studentInfo.creditStatus_dictText === '是' ? 'success' : 'error'
              "
            >
              {{ studentInfo.creditStatus_dictText }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 学费 -->
    <div class="card tuition-info-card">
      <div class="card-header">
        <h3>学费</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>应缴学费金额</label>
            <div class="form-value">{{ studentInfo.payableAmount }}</div>
          </div>
          <div class="form-item">
            <label>已缴学费金额</label>
            <div class="form-value">{{ studentInfo.paidAmount }}</div>
          </div>
          <div class="form-item">
            <label>欠费金额</label>
            <div class="form-value">{{ studentInfo.arrearsAmount }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 申请信息 -->
    <div class="card apply-form-card">
      <div class="card-header">
        <h3>申请信息</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item" v-if="studentInfo.foreignLanguageExempt === 0">
            <label>学位外语成绩</label>
            <div class="form-value">{{ studentInfo.foreignLanguageScore }}</div>
          </div>
          <div class="form-item">
            <label>学位外语是否免考</label>
            <div
              class="form-value"
              :class="
                studentInfo.foreignLanguageExempt_dictText === '是'
                  ? 'success'
                  : 'error'
              "
            >
              {{ studentInfo.foreignLanguageExempt_dictText }}
            </div>
          </div>
        </div>
        <!-- 当学位外语是否免考为是，或者已经上传了免考证书时，显示免考证书上传部分 -->
        <div class="form-row" v-if="studentInfo.foreignLanguageExempt === 1 || (studentInfo.exemptionCertificate && studentInfo.exemptionCertificate !== '0')">
          <div class="form-item" style="flex: 1; min-width: 100%">
            <label>免考证书上传 <span style="color: red" v-if="studentInfo.foreignLanguageExempt === 1">*</span></label>
            <div class="upload-container">
              <ChangeUpload
                ref="childRef"
                :fileKey="fileKey"
                :checkFlag="checkFlag"
                :type="type"
                @uploadSuccessList="uploadSuccessList"
                @uploadSuccess="uploadSuccess"
              ></ChangeUpload>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <a-button
            type="primary"
            class="btn-submit"
            @click="submit"
            v-if="studentInfo.finalStatus === 0"
          >
            提交申请
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeUpload from "../ChangeUpload.vue";
export default {
  name: "graduateApplyForm",
  components: {
    ChangeUpload,
  },
  data: function () {
    return {
      applyType: "graduate",
      checkFlag: true,
      type: 0,
      fileKey: "",
      uploadingName: "",
      uploadingList: "",
      studentInfo: {},
      loading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    uploadSuccessList(val) {
      // 只保留最后上传的文件
      if (val && val.length > 0) {
        this.uploadingList = val[val.length - 1].toString();
      } else {
        this.uploadingList = "";
      }
    },
    uploadSuccess(val) {
      // 只保留最后上传的文件
      if (val && val.length > 0) {
        this.uploadingName = val[val.length - 1].toString();
        // 直接修改上传组件的状态，只保留最后上传的文件
        if (this.$refs.childRef) {
          // 只保留最后上传的文件信息
          this.$refs.childRef.fileList = [this.uploadingList];
          this.$refs.childRef.fileListName = [this.uploadingName];
          // 构建完整的文件对象，支持点击下载
          const fileObj = {
            uid: Date.now(),
            name: this.uploadingName,
            status: "done",
            url: this.uploadingList,
          };
          // 设置到 aloneFileList 中
          this.$refs.childRef.aloneFileList = [fileObj];
        }
      } else {
        this.uploadingName = "";
      }
    },
    getData() {
      this.loading = true;
      this.axios
        .get(`/degree/stuDegree/stuGraInfo?type=apply`)
        .then((res) => {
          this.loading = false;
          if (res && res.code === 200 && res.result) {
            this.studentInfo = res.result;
            // 检查是否有已上传的文件
            if (
              this.studentInfo.exemptionCertificate &&
              this.studentInfo.exemptionCertificate !== null
            ) {
              // 构建文件列表
              const fileName = this.studentInfo.exemptionCertificate
                .split("/")
                .pop();
              const fileList = [
                {
                  uid: Date.now(),
                  name: fileName,
                  status: "done",
                  url: this.studentInfo.exemptionCertificate,
                },
              ];
              // 设置上传的文件信息
              this.uploadingList = this.studentInfo.exemptionCertificate;
              this.uploadingName = fileName;
              // 如果上传组件已经渲染完成，直接设置文件列表
              if (this.$refs.childRef) {
                this.$refs.childRef.defaultFileList = fileList;
                this.$refs.childRef.aloneFileList = fileList;
              } else {
                // 如果上传组件还没有渲染完成，稍后再设置
                this.$nextTick(() => {
                  if (this.$refs.childRef) {
                    this.$refs.childRef.defaultFileList = fileList;
                    this.$refs.childRef.aloneFileList = fileList;
                  }
                });
              }
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取学生信息失败:", error);
          this.$message.error("获取学生信息失败，请稍后重试");
        });
    },
    submit() {
      // 验证：当学位外语是否免考为是时，必须上传免考证书
      if (
        this.studentInfo.foreignLanguageExempt_dictText === "是" &&
        (!this.uploadingName || !this.uploadingList)
      ) {
        this.$message.error("学位外语免考时必须上传免考证书");
        return;
      }

      // 处理上传的文件
      let docList = [];
      if (this.uploadingName && this.uploadingList) {
        // 只处理单个文件
        docList = [
          {
            docUrl: this.uploadingList,
            docName: this.uploadingName,
          },
        ];
      }

      let params = {
        applyType: this.applyType,
        docList: docList,
      };

      this.axios
        .post(`/degree/stuDegree/submitApply`, params)
        .then((res) => {
          if (res && res.code === 200) {
            this.$message.success("提交成功");
            // 重新获取学生信息，包括已上传的文件
            this.getData();
          } else {
            this.$message.error((res && res.message) || "提交失败，请稍后重试");
          }
        })
        .catch((error) => {
          console.error("提交申请失败:", error);
          this.$message.error("提交失败，请稍后重试");
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.graduate-apply-form {
  background: #f5f5f5;
  padding: 20px;
  margin-top: 20px;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow: hidden;
}

.card-header {
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 24px;
}

.card-header h3 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.card-body {
  padding: 24px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;
  margin-bottom: 16px;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-item {
  flex: 1;
  min-width: 250px;
  padding: 0 12px;
  margin-bottom: 16px;
}

.form-item label {
  display: block;
  font-size: 14px;
  color: #999;
  margin-bottom: 8px;
}

.form-item .form-value {
  font-size: 14px;
  color: #333;
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 4px;
  min-height: 32px;
  display: flex;
  align-items: center;
}

.form-item .success {
  color: #52c41a;
}

.form-item .error {
  color: #ff4d4f;
}

.form-item .status {
  color: #1890ff;
}

.upload-container {
  width: 100%;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  padding: 20px;
  background: #fafafa;
  margin-top: 8px;

  &:hover {
    border-color: #2caf7a;
  }
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
}

.btn-submit {
  background: #2caf7a;
  color: #fff;
  width: 120px;
  height: 36px;
  font-size: 14px;
}

.btn-submit:hover {
  background: #259d8a;
  border-color: #259d8a;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-item {
    min-width: 100%;
  }

  .card-body {
    padding: 16px;
  }

  .card-header {
    padding: 12px 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/graduateApplyTabs/apply.vue